import { useState, type ReactNode } from 'react';
import FAQSchema from '../../seo/FAQSchema';
import { MULTI_CHANNEL_FAQS } from '../../data/multiChannelFaqs';
import '../Homepage/FAQ.css';

type McfFaq = {
  id: number;
  question: string;
  answer: ReactNode;
  answerText: string;
};

const PLATFORM_ANSWER = (
  <>
    We support{' '}
    <a href="https://sell.amazon.co.uk" target="_blank" rel="noopener noreferrer nofollow">
      Amazon FBA
    </a>
    , Shopify, eBay and TikTok Shop — plus 650+ integrations via our WMS and middleware where needed.
  </>
);

const faqs: McfFaq[] = MULTI_CHANNEL_FAQS.map((item, index) => ({
  id: index + 1,
  question: item.question,
  answer:
    item.question === 'Which platforms do you support?' ? PLATFORM_ANSWER : item.answer,
  answerText: item.answer,
}));

const MultiChannelFAQs = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="faqs-section">
      <FAQSchema
        faqs={MULTI_CHANNEL_FAQS}
        id="mcf-faq-schema"
        nonce="ppp-2026-gtm-nonce"
      />
      <div className="faqs-container">
        <div className="faqs-header">
          <h2 className="faqs-title">Multi Channel Fulfilment FAQs</h2>
          <p className="faqs-description">
            Centralise stock, route orders smartly and keep every channel in sync — practical answers on ecommerce fulfilment UK and multi-channel operations.
          </p>
        </div>

        <div className="faqs-content">
          <div className="faqs-list">
            {faqs.map((faq, index) => (
              <div
                key={faq.id}
                className={`faq-item ${openIndex === index ? 'faq-open' : ''}`}
              >
                <div
                  className="faq-question-wrapper"
                  onClick={() => toggleFAQ(index)}
                >
                  <h3 className="faq-question">{faq.question}</h3>
                  <button
                    className={`faq-toggle ${openIndex === index ? 'faq-toggle-open' : ''}`}
                    aria-label={openIndex === index ? 'Close answer' : 'Open answer'}
                    onClick={(e) => {
                      e.stopPropagation();
                      toggleFAQ(index);
                    }}
                  >
                    <svg width="32" height="32" viewBox="0 0 20 20" fill="none">
                      {openIndex === index ? (
                        <path d="M5 10H15" stroke="currentColor" strokeWidth="3.5" strokeLinecap="round"/>
                      ) : (
                        <>
                          <path d="M10 5V15" stroke="currentColor" strokeWidth="3.5" strokeLinecap="round"/>
                          <path d="M5 10H15" stroke="currentColor" strokeWidth="3.5" strokeLinecap="round"/>
                        </>
                      )}
                    </svg>
                  </button>
                </div>
                <div className={`faq-answer ${openIndex === index ? 'faq-answer-open' : ''}`}>
                  <p>{faq.answer}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="faqs-image-wrapper">
            <img
              src="/Images/merchent/FAQ_image.webp"
              alt="Multi-channel fulfilment FAQs"
              className="faqs-image"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default MultiChannelFAQs;
